import React from 'react'
import EnterpriseForm from "../components/enterprise-form"
import BusinessForm from "../components/business-form"
import { Region } from '../types/regions'
import { getRegions } from '../services/get-regions'
import IndividualForm from "../components/individual-form"
import { useOutletContext } from 'react-router'
import { BUSINESS_PLAN, REGION } from '../constants/constants'
import { getBusinessPlans } from '../services/get-business-plans'
import { Business } from '../types/business-plan'

const Subscribe = () => {
    // console.log('render')
    const [type, setType] = React.useState('individual')
    const [loading, setLoading] = useOutletContext<any>()
    const [plans, setPlans] = React.useState<Business[]>(BUSINESS_PLAN)
    const [regions, setRegions] = React.useState<Region[]>(REGION)

    const toggleEnterprise = (value: string) => {
        if (value === 'enterprise' && type !== 'enterprise') {
            setType('enterprise')
        }
        if (value === 'business' && type !== 'business') {
            setType('business')
        }
        if (value === 'individual' && type !== 'individual') {
            setType('individual')
        }
    }

    const FreePlanInfo = () => {
        return (
            <div className='text-center mx-auto py-16 font-poppins w-11/12'>
                <p className='text-2xl'><span className='text-[#1D58E2] font-semibold'>Free Subscription Plan</span> is exclusively available for individual users, allowing a <span className='text-[#F00]'>single user</span> to access all our application services without any charge.</p>
            </div>
        )
    }

    const fetchData = async () => {
        try {
            setLoading(true)
            const businessPlans = await getBusinessPlans()
            const regions = await getRegions()
            setPlans(businessPlans)
            setRegions(regions)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }

    React.useEffect(() => {
        fetchData()
    }, [])

    return (
        <div>
            <div id='main-content' className="">
                <div className="flex flex-col items-center">
                    <div className="bg-[#1D58E2] py-10 w-full flex items-center justify-center ">
                        <div className="flex items-center justify-evenly bg-[#1D58E2] text-center border-2 border-white">
                            <p className={`px-14 text-lg max-[768px]:px-3 py-2 font-inter font-semibold cursor-pointer ${type === 'individual' ? 'bg-white text-[#1D58E2] shadow-sm' : 'text-white'}`} onClick={() => toggleEnterprise('individual')}>Individual/Home Users</p>
                            <p className={`px-14 text-lg max-[768px]:px-3 py-2 font-inter font-semibold cursor-pointer border-r-2 border-l-2 border-white ${type === 'business' ? 'bg-white text-[#1D58E2] shadow-sm' : 'text-white'}`} onClick={() => toggleEnterprise('business')}>Small Business</p>
                            <p className={`px-14 text-lg max-[768px]:px-3 py-2 font-inter font-semibold cursor-pointer ${type === 'enterprise' ? 'bg-white text-[#1D58E2] shadow-sm' : 'text-white'}`} onClick={() => toggleEnterprise('enterprise')}>Enterprise</p>
                        </div>
                    </div>
                </div>
                {type === 'individual' &&
                    <FreePlanInfo />
                }
                {type === 'enterprise' ?
                    <EnterpriseForm regions={regions} setLoading={setLoading} />
                    :
                    type === 'business' ?
                        <BusinessForm plans={plans} regions={regions} setLoading={setLoading} />
                        :
                        <IndividualForm regions={regions} setLoading={setLoading} />
                }
            </div>
        </div>
    )
}

export default Subscribe